import './index.css'
import './i18n'

import * as Sentry from '@sentry/react'
import { QueryClientProvider } from '@tanstack/react-query'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'

import App from './App'
import { hydrateAuthTokens, initNativeShell } from './lib/native'
import { queryClient } from './lib/queryClient'
import { initSentry } from './lib/sentryInit'
import store from './store/store'

if (window.navigator && navigator.serviceWorker) {
  navigator.serviceWorker.getRegistrations().then(function (registrations) {
    for (const registration of registrations) {
      registration.unregister()
    }
  })
}

void (async () => {
  await initSentry()
  await hydrateAuthTokens()
  await initNativeShell()
  createRoot(document.getElementById('root')!).render(
    <Sentry.ErrorBoundary
      fallback={
        <div className='flex min-h-[100dvh] flex-col items-center justify-center gap-3 p-6 text-center'>
          <p className='text-lg font-medium'>Something went wrong</p>
          <button type='button' className='underline' onClick={() => window.location.reload()}>
            Reload
          </button>
        </div>
      }
    >
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <Router>
            <App />
          </Router>
        </Provider>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  )
})()
